import { useEffect, useState } from "react";
import { Table } from "reactstrap";
import axios from "../../axios/axios";
import AddPartner from "./AddPartner/AddPartner";
import Partner from "./Partner/Partner";

const Partners = () => {
  const [partners, setPartners] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    const getPartners = async () => {
      try {
        const res = await axios.get("/partners");
        console.log(res?.data?.body?.data);
        setPartners(res?.data?.body?.data);
      } catch (err) {
        console.log(err);
      }
    };

    getPartners();
  }, [isUpdate]);

  return (
    <div>
      <h2>Partners</h2>
      <div className="mb-3">
        <AddPartner isUpdate={isUpdate} setIsUpdate={setIsUpdate} />
      </div>
      {partners.length ? (
        <Table responsive>
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Name</th>
              <th scope="col">Description</th>
              <th scope="col">Image</th>
              <th scope="col">Website</th>
              <th scope="col">Action</th>
            </tr>
          </thead>
          <tbody>
            {partners?.map((partner, index) => (
              <Partner
                key={partner?.id}
                slider={partner}
                index={index}
                isUpdate={isUpdate}
                setIsUpdate={setIsUpdate}
              />
            ))}
          </tbody>
        </Table>
      ) : (
        <p>No data found.</p>
      )}
    </div>
  );
};

export default Partners;
